import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import Datepicker from 'vuejs-datepicker';
import { de } from 'vuejs-datepicker/dist/locale';
import { initClient } from "../../../api";
import { Cell, CellClient, OeeCellShiftApiClient } from '../../backend/backendapi';


am4core.useTheme(am4themes_animated);
am4core.options.commercialLicense = true;

@Component(
    {
        name: 'ReportOeeCellShift',
        components: {
            vSelect,
            Datepicker
        }
    })
export default class ReportOeeCellShift extends Vue {
    private readonly datepickerDE: any = de;
    private readonly uid = Math.floor(Math.random() * 1333333337);
    private chart: any;
    private dateAxis: any;
    private valueAxis: any;
    private actualSeries: any;
    private expectedSeries: any;


    private cells: Cell[] = [];
    private shifts: any[] = [{ id: 0, name: '0' }, { id: 1, name: '1' }, { id: 2, name: '2' }];
    private cellId: number | null = null;
    private shiftId: number | null = null;
    private startDate: Date = new Date();
    mounted(): void {
        this.chart = am4core.create('chartdiv_' + this.uid, am4charts.XYChart);

        // Create axes
        this.dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
        this.dateAxis.renderer.minGridDistance = 60;

        this.valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

        this.actualSeries = this.chart.series.push(new am4charts.LineSeries());
        this.actualSeries.dataFields.valueY = "value_act";
        this.actualSeries.dataFields.dateX = "date_act";
        this.actualSeries.yAxis = this.valueAxis;
        this.actualSeries.xAxis = this.dateAxis;
        this.actualSeries.tooltipText = "{value}"
        this.actualSeries.color = "#ff0000"
        this.actualSeries.fill = am4core.color("#ff0000");
        this.actualSeries.stroke = am4core.color("#ff0000");

        this.expectedSeries = this.chart.series.push(new am4charts.LineSeries());
        this.expectedSeries.dataFields.valueY = "value_exp";
        this.expectedSeries.dataFields.dateX = "date_exp";
        this.expectedSeries.yAxis = this.valueAxis;
        this.expectedSeries.xAxis = this.dateAxis;
        this.expectedSeries.tooltipText = "{value}"

        this.chart.cursor = new am4charts.XYCursor();
        this.chart.cursor.snapToSeries = this.actualSeries;
        this.chart.cursor.xAxis = this.dateAxis;

        this.reloadCells();
    }

    async reloadCells(): Promise<void> {
        const cells = await initClient(CellClient).getCellsData();
        console.log(cells);
        this.cells.splice(0);
        this.cells.push(...cells);
    }

    @Watch('cellId')
    @Watch('shiftId')
    @Watch('startDate')
    async reloadData(): Promise<void> {
        if (this.cellId === null || this.shiftId === null) {
            return;
        }
        let data = (await initClient(OeeCellShiftApiClient).data(this.cellId, this.shiftId, this.startDate)).result!;
        for (let i = 1; i < data.length; i++) {
            data[i].value = data[i - 1].value! + data[i].value!;
        }
        let cumulativeData = data.map(d => { return { value_act: d.value, date_act: d.date }; }) //map to series
            .map(d => { return { value_act: d.value_act! / data.length * 100, date_act: d.date_act }; }); //normalize to 100%

        this.chart.data.splice(0);
        this.chart.data = this.chart.data.concat(cumulativeData);
        // this.chart.data = this.chart.data.concat(
        //     { value_exp: 100 / data.length, date_exp: new Date(new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate()).getTime() + this.shiftId * 8 * 60 * 60 * 1000) },
        //     { value_exp: 100, date_exp: new Date(new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate()).getTime() + (this.shiftId + 1) * 8 * 60 * 60 * 1000) });
        if (data.length > 0) {
            this.chart.data = this.chart.data.concat(
                { value_exp: 100 / data.length, date_exp: data[0].date },
                { value_exp: 100, date_exp: data[data.length - 1].date });
        }
    }
}